export default __webpack_public_path__ + "graphics/stockings.274d7eb7.jpg";